import { type MouseEvent } from 'react';
import { trackEvent, eventNameConstants, interactionTypeConstants } from 'dibs-tracking';

const GO_TO_CART_TRIGGER = 'go to cart';
const GO_TO_CART_STEP = 'cart added notification go to cart click';

const CART_MOBILE_NOTIFICATION = 'cart-mobile-notification';
const CART_DESKTOP_NOTIFICATION = 'cart-desktop-notification';

export function trackCartAddedGoToCart(
    event?: MouseEvent<HTMLElement> | null,
    isMobile: boolean = false
): void {
    trackEvent(
        {
            label: GO_TO_CART_TRIGGER,
            category: eventNameConstants.EVENT_NAVIGATION,
            action: GO_TO_CART_STEP,
            eventName: eventNameConstants.EVENT_NAVIGATION,
            interaction_type: interactionTypeConstants.INTERACTION_TYPE_GLOBAL_NAV,
            step_interaction_name: GO_TO_CART_STEP,
            trigger: isMobile ? CART_MOBILE_NOTIFICATION : CART_DESKTOP_NOTIFICATION,
        },
        event
    );
}
